import { motion } from "framer-motion";
import { useState } from "react";
import emailjs from "emailjs-com";

function ContactForm({ id }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);

    // Configura los parámetros de EmailJS
    emailjs
      .sendForm(
        "service_77sgkrr", // Servicio de correo (obtenido en EmailJS)
        "template_yn9sl5c", // ID del template (obtenido en EmailJS)
        e.target, // El formulario
        'hbLPKeGKo8fZMJH0R'
      )
      .then(
        (result) => {
          console.log(result.text);
          setSuccess(true);
          setSending(false);
        },
        (error) => {
          console.log(error.text);
          setSending(false);
        }
      );
  };

  return (
    <div className="py-16 px-6 bg-background" id={id}>
      <motion.h4
        className="text-center text-3xl font-semibold text-secondary mb-8"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Contáctanos
      </motion.h4>

      <motion.form
        className="max-w-xl mx-auto flex flex-col gap-6 bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        onSubmit={handleSubmit}
      >
        <motion.input
          type="text"
          name="name"
          placeholder="Nombre"
          value={formData.name}
          onChange={handleChange}
          className="w-full p-4 bg-gray-100 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          required
        />
        <motion.input
          type="email"
          name="email"
          placeholder="Correo Electrónico"
          value={formData.email}
          onChange={handleChange}
          className="w-full p-4 bg-gray-100 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          required
        />
        <motion.textarea
          name="message"
          placeholder="Mensaje"
          rows="4"
          value={formData.message}
          onChange={handleChange}
          className="w-full p-4 bg-gray-100 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          required
        />
        <motion.button
          type="submit"
          className="w-full py-3 text-lg font-semibold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-xl"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          disabled={sending}
        >
          {sending ? "Enviando..." : "Enviar"}
        </motion.button>
        {success && (
          <p className="mt-4 text-center text-green-500 font-semibold">
            ¡Mensaje enviado con éxito!
          </p>
        )}
      </motion.form>
    </div>
  );
}

export default ContactForm;
